import { createContext } from 'react';
import { IDevices } from 'types';

export type TDevicesSortBy =
	| ''
	| 'HardwareID1-10'
	| 'HardwareID10-1'
	| 'RestaurantA-Z'
	| 'RestaurantZ-A'
	| 'CustomerA-Z'
	| 'CustomerZ-A';
export type TCountOfDevices = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	sortBy: TDevicesSortBy;
	countOfItems: TCountOfDevices;
	currentPage: number;
}

export interface IDevicesState {
	devices: IDevices;
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	sortBy: TDevicesSortBy;
	countOfItems: TCountOfDevices;
	currentPage: number;
	deviceIDForDeletion: string;
	deviceIDForFullInfo: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const devicesInitialState: IDevicesState = {
	devices: { count: 0, items: [] },
	searchString: '',
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	deviceIDForDeletion: '',
	deviceIDForFullInfo: '',
	typeOfModalWindow: null,
};

export interface IDevicesContext extends IDevicesState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TDevicesSortBy): void;
	setCountOfItems(count: TCountOfDevices): void;
	changeCurrentPage(page: number): void;
	setDeviceIDForDeletion(deviceID: string): void;
	setDeviceIDForFullInfo(deviceID: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const DevicesContext = createContext<IDevicesContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setDeviceIDForDeletion: () => undefined,
	setDeviceIDForFullInfo: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...devicesInitialState,
});
